const asset_master_category = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/category/index.vue')
const asset_master_item = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/item/index.vue')
const asset_master_location = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/location/index.vue')
const asset_master_supplier = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/supplier/index.vue')
const asset_master_condition = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/condition/index.vue')
// const asset_master_stock = () => import(/* webpackPrefetch: true */ '@/views/private/asset/master/stock/index.vue')

const asset_data_stock = () => import(/* webpackPrefetch: true */ '@/views/private/asset/stock/index.vue')

const asset_data_request = () => import(/* webpackPrefetch: true */ '@/views/private/asset/request/index.vue')

const asset_data_procurement = () => import(/* webpackPrefetch: true */ '@/views/private/asset/procurement/index')

const asset_data_maintenance = () => import(/* webpackPrefetch: true */ '@/views/private/asset/maintenance/index')

const asset_data_determination = () => import(/* webpackPrefetch: true */ '@/views/private/asset/determination/index')

const asset_data_barcode = () => import(/* webpackPrefetch: true */ '@/views/private/asset/barcode/index')

const routes = [
  {
    path: "/asset/master/category",
    name: "Kategori",
    component: asset_master_category,
    meta: {
      title: "Kategori"
    }
  },


  {
    path: "/asset/master/item",
    name: "Item",
    component: asset_master_item,
    meta: {
      title: "Item"
    }
  },


  {
    path: "/asset/master/location",
    name: "Lokasi",
    component: asset_master_location,
    meta: {
      title: "Lokasi"
    }
  },


  {
    path: "/asset/master/supplier",
    name: "Supplier",
    component: asset_master_supplier,
    meta: {
      title: "Supplier"
    }
  },


  {
    path: "/asset/master/condition",
    name: "Kondisi",
    component: asset_master_condition,
    meta: {
      title: "Kondisi"
    }
  },

  // {
  //   path: "/asset/master/stock",
  //   name: "Stok",
  //   component: asset_master_stock,
  //   meta: {
  //     title: "Stok"
  //   }
  // },

  {
    path: "/asset/stock",
    name: "Stok",
    component: asset_data_stock,
    meta: {
      title: "Stok"
    }
  },


  {
    path: "/asset/request",
    name: "Permintaan Pengadaan",
    component: asset_data_request,
    meta: {
      title: "Permintaan Pengadaan"
    }
  },

  {
    path: "/asset/procurement",
    name: "Pengadaan",
    component: asset_data_procurement,
    meta: {
      title: "Pengadaan"
    }
  },

  {
    path: "/asset/maintenance",
    name: "Pemeliharaan",
    component: asset_data_maintenance,
    meta: {
      title: "Pemeliharaan"
    }
  },

  {
    path: "/asset/determination",
    name: "Monitoring Lokasi",
    component: asset_data_determination,
    meta: {
      title: "Monitoring Lokasi"
    }
  },

  {
    path: "/asset/barcode",
    name: "Barcode / QR Kode",
    component: asset_data_barcode,
    meta: {
      title: "Barcode / QR Kode"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})